(function() {
    'use strict';

    angular.module('app.centrosCosto', []);
})();
